<template>
    <div 
      class="mt-4">
      <v-layout wrap>
        <v-flex>
          <v-dialog v-model="dialog.form"
            @keydown.esc="dialog.form = false"
            :fullscreen="dialog.fullscreen"
            width="600"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center px-4 py-2 text-right popup-header">
                <div
                  class="fs-16 font_weight_700">
                  {{ form.id === '' ? 'Tambah' : 'Ubah' }} Data Keluarga
                </div>
  
                <v-spacer/>
  
                <!-- <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon> -->
  
                <v-icon 
                  @click="dialog.form = false; dialog.fullscreen = false;"
                  class="cursor-pointer"
                  size="22"
                  color="#9ca3af">
                  mdi-close
                </v-icon>
              </v-card-title>
  
              <v-divider 
                class="mt-0"
                style="border-top: 1px solid #e0e0e0;"/>
  
              <v-card-text 
                class="py-0 my-4">
                <ValidationObserver 
                  ref="form">
                  <v-form>
                    <v-row>
                      <v-col cols="12" md="12">
                        <v-row>
                          <v-col cols="12" md="12" class="py-0">
                            <ValidationProvider 
                              name="Nama Keluarga" 
                              rules="required" 
                              v-slot="{ errors }">
                              <div class="fs-13 mb-1">
                                
                                Nama Keluarga

                            <span class="red--text">*</span>
                              </div>
      
                              <v-text-field
                                
                                
                                solo
                                rounded
                                dense
      
                                :color="set_color"
                                placeholder="Contoh. xxxxxxxxx"
                                v-model="form.name"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;"
                                class="mb-0">
                              </v-text-field>
                            </ValidationProvider>

                            <ValidationProvider 
                              name="No Telephone" 
                              rules="" 
                              v-slot="{ errors }">
                              <div class="fs-13 mb-1">
                                
                                No Telephone

                            <!-- <span class="red--text">*</span> -->
                              </div>
      
                              <v-text-field
                                
                                
                                solo
                                rounded
                                dense
                                type="number"
                                min="0"
                                prefix="+62"
      
                                :color="set_color"
                                placeholder="Contoh. xxxxxxxxx"
                                v-model="form.mobile_phone_number"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;"
                                class="mb-0">
                              </v-text-field>
                            </ValidationProvider>

                            <v-row>
                              <v-col cols="12" md="6" class="py-0">

                                <ValidationProvider 
                                  name="Jenis Kelamin" 
                                  rules="required" 
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Jenis Kelamin
                                    <span class="red--text">*</span>
                                  </div>
          
                                  <v-autocomplete
                                    
                                    
                                    solo
                                    rounded
                                    dense
                                    :items="[
                                      {
                                        text: 'Laki-laki',
                                        value: 'Laki-laki'
                                      },
                                      {
                                        text: 'Perempuan',
                                        value: 'Perempuan'
                                      }
                                    ]"
                                    item-value="value"
                                    item-text="text"
          
                                    :color="set_color"
                                    placeholder="Contoh. Laki-laki"
          
                                    
          
                                    v-model="form.gender"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    class="mb-0">
                                  </v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Hubungan" 
                                  rules="required" 
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Hubungan

                                    <span class="red--text">*</span>
                                  </div>
          
                                  <v-text-field
                                    
                                    
                                    solo
                                    rounded
                                    dense
          
                                    :color="set_color"
                                    placeholder="Contoh. xxxxxxxxx"
                                    v-model="form.relation"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    class="mb-0">
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Tempat Lahir" 
                                  rules="required" 
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Tempat Lahir

                                    <span class="red--text">*</span>
                                  </div>
          
                                  <v-text-field
                                    
                                    
                                    solo
                                    rounded
                                    dense
          
                                    :color="set_color"
                                    placeholder="Contoh. xxxxxxxxx"
                                    v-model="form.birth_place"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    class="mb-0">
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Tanggal Lahir" 
                                  rules="required" 
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Tanggal Lahir

                                    <span class="red--text">*</span>
                                  </div>
          
                                  <v-text-field
                                    
                                    
                                    solo
                                    rounded
                                    dense
          
                                    :color="set_color"
                                    placeholder="Tanggal Lahir"
                                    type="date"
                                    
                                    v-model="form.birth_date"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    class="mb-0">
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Pekerjaan" 
                                  rules="" 
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Pekerjaan

                                  <!-- <span class="red--text">*</span> -->
                                  </div>
          
                                  <v-autocomplete
                                    
                                    
                                    solo
                                    rounded
                                    dense
                                    :items="[
                                      'Pegawai Negeri Sipil', 'TNI/POLRI', 'Guru/Dosen', 'Karyawan Swasta', 'Karyawan BUMN/BUMD', 'Tenaga Medis', 'Pegawai Bank', 'Notaris/Pengacara', 'Petani/Pembudidaya', 'Pedagang', 'Nelayan', 'Tukang', 'Sopir/Ojek Online', 'Buruh Harian', 'Wiraswasta', 'Freelancer', 'Konsultan', 'Seniman', 'Influencer', 'Penjahit', 'Montir', 'Koki', 'Pemandu Wisata', 'Petugas Kebersihan', 'Ibu Rumah Tangga', 'Asisten Rumah Tangga', 'Tidak Bekerja', 'Pensiunan', 'Mahasiswa'
                                    ]"
          
                                    :color="set_color"
                                    placeholder="Contoh. xxxxxxxxx"
                                    v-model="form.job"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    class="mb-0">
                                  </v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Pengahasilan" 
                                  rules="" 
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Pengahasilan
                                    <!-- <span class="red--text">*</span> -->
                                  </div>
          
                                  <v-currency-field
                                    
                                    solo
                                    rounded
                                    dense
          
                                    :color="set_color"
                                    :allow-negative="false"
                                    prefix="Rp. "
                                    placeholder="Contoh. xxxxxxxxx"
                                    v-model="form.penghasilan"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    class="mb-0">
                                  </v-currency-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Status" 
                                  rules="required" 
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Status
                                    <span class="red--text">*</span>
                                  </div>
          
                                  <v-autocomplete
                                    
                                    
                                    solo
                                    rounded
                                    dense

                                    :items="[
                                      {
                                        text: 'Ada',
                                        value: 'Ada'
                                      },
                                      {
                                        text: 'Sudah Meninggal',
                                        value: 'Sudah Meninggal'
                                      },
                                      {
                                        text: 'Tidak Ada',
                                        value: 'Tidak Ada'
                                      }
                                    ]"
                                    item-value="value"
                                    item-text="text"
          
                                    :color="set_color"
                                    placeholder="Contoh. xxxxxxxxx"
                                    v-model="form.status"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    class="mb-0">
                                  </v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Pendidikan Terakhir" 
                                  rules="" 
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Pendidikan Terakhir
                                  </div>
          
                                  <v-autocomplete
                                    
                                    
                                    solo
                                    rounded
                                    dense
                                    :items="[
                                      {
                                        text: 'Tidak Sekolah',
                                        value: 'Tidak Sekolah'
                                      },
                                      {
                                        text: 'SD/Sederajat',
                                        value: 'SD/Sederajat'
                                      },
                                      {
                                        text: 'SMP/Sederajat',
                                        value: 'SMP/Sederajat'
                                      },
                                      {
                                        text: 'SMA/Sederajat',
                                        value: 'SMA/Sederajat'
                                      },
                                      {
                                        text: 'Diploma (D1)',
                                        value: 'Diploma (D1)'
                                      },
                                      {
                                        text: 'Diploma (D2)',
                                        value: 'Diploma (D2)'
                                      },
                                      {
                                        text: 'Diploma (D3)',
                                        value: 'Diploma (D3)'
                                      },
                                      {
                                        text: 'Diploma (D4)',
                                        value: 'Diploma (D4)'
                                      },
                                      {
                                        text: 'Sarjana (S1)',
                                        value: 'Sarjana (S1)'
                                      },
                                      {
                                        text: 'Magister (S2)',
                                        value: 'Magister (S2)'
                                      },
                                      {
                                        text: 'Doktor (S3)',
                                        value: 'Doktor (S3)'
                                      }
                                    ]"
                                    item-value="value"
                                    item-text="text"
          
                                    :color="set_color"
                                    placeholder="Contoh. xxxxxxxxx"
                                    v-model="form.last_education"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    class="mb-0">
                                  </v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                            </v-row>

                            <ValidationProvider 
                              name="Alamat" 
                              rules="required" 
                              v-slot="{ errors }">
                              <div class="fs-13 mb-1">
                                
                                Alamat

                              <span class="red--text">*</span>
                              </div>
      
                              <v-text-field
                                
                                
                                solo
                                rounded
                                dense
      
                                :color="set_color"
                                placeholder="Contoh. xxxxxxxxx"
                                v-model="form.address"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;"
                                class="mb-0">
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-form>
                </ValidationObserver>
  
              </v-card-text>
              
              <v-divider 
                class="mt-2"
                style="border-top: 1px solid #e0e0e0;"/>
              
              <v-card-actions
                class="pa-4">
                <div v-if="message.error.length > 0"
                  class="text-left mt-0">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
                <v-spacer/>
  
                <v-btn
                  @click="save()"
                  :loading="process.form"
                  :disabled="process.form"
                  width="85"
                  elevation="0"
                  :color="set_color"
                  style="border-radius: 6px;"
                  class="fs-13 font-weight-bold text-capitalize white--text">
                  Simpan
                </v-btn>
  
                <v-btn
                  @click="dialog.form = false; reset();"
                  :disabled="process.form"
                  width="85"
                  outlined
                  elevation="0"
                  color="red"
                  style="border-radius: 6px;"
                  class="fs-13 font-weight-bold text-capitalize white--text">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  
          <v-dialog v-model="dialog.delete"
            @keydown.esc="dialog.delete = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
              <v-card-title 
                class="d-flex align-center pa-4 text-right popup-header">
                Hapus Data
  
                <v-spacer/>
  
                <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  :color="set_color">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon>
              </v-card-title>
              
              <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second mt-4">
                Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
              </v-card-text>
  
              <div v-if="message.error.length > 0"
                class="text-center mx-6 my-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
  
              <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/>
  
              <v-card-actions
                class="pa-4">
                <v-spacer/>
  
                <v-btn
                  rounded
                  width="120"
                  @click="deletes()"
                  :loading="process.delete"
                  :disabled="process.delete"
                  color="green"
                  elevation="0"
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Ya, Hapus
                </v-btn>
  
                <v-btn
                  rounded
                  width="120"
                  @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                  :disabled="process.delete"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Batal
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <section>
            <v-row
              class="pa-4 pb-0 pt-0">
              <v-col
                cols="12" class="pb-1 pt-1">
                <v-card
                  flat
                  @click="$router.go(-1)"
                  style="cursor: pointer;"
                  color="#ffffff">
                  <v-card-text>
                    <div
                      class="d-flex align-center">
                      <div
                        class="d-flex align-center">
                        <v-icon
                          size="24"
                          :color="set_color">
                          mdi-backburger
                        </v-icon>
    
                        <div
                          class="fs-16 black--text ml-3"
                          style="font-weight: 600; padding-top: 1px;">
                          {{ $route.meta.title }}
                        </div>
                      </div>

                      <div class="ml-auto">
                        <v-btn
                          :disabled="process.form"
                          dark
                          elevation="0"
                          small
                          @click="dialog.form = true; editFamily();"
                          :color="set_color"
                          class="white--text text-capitalize"
                          style="border-radius: 6px;">
                          Download
                        </v-btn>
                      </div>
    
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
  
            <v-row
              class="pa-4">
              <v-col 
                cols="12"
                class="py-0">
                <v-card flat v-if="process.load" >
                  <v-card-text
                    v-if="process.load" 
                    class="pb-0 my-4" 
                    style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-4 title">
                        Mohon Tunggu . . .
                      </div>
    
                      <v-progress-linear
                        :color="set_color"
                        indeterminate
                        rounded
                        height="10">
                      </v-progress-linear>
                    </div>
                  </v-card-text>
                </v-card>
                <v-card 
                  flat
                  v-if="!process.load && Object.keys(detail).length > 0"
                  style="background-color: transparent;">
                  <v-card-text class="pa-0">
                    <v-card flat 
                      style="border-radius: 6px;">
                      <v-card-text>
                        <!-- <v-img
                          :src="form.logo_url !== undefined && form.logo_url !== '' ? form.logo_url : require('@/assets/image/image_default.png')"
                          max-height="150"
                          max-width="150"
                          class="">
                        </v-img>
                        <div class="d-flex pt-3 align-end">
                          <div class="">
                            <div class="font_weight_600 black--text fs-14">
                              {{ form.name }}
                            </div>
                            <div class="black--text fs-13 pt-1" style="font-weight: 600;">
                              {{ form.address }}, {{ form.village_name }}, {{ form.district_name }}, {{ form.city_name }}, {{ form.province_name }}
                            </div>
                          </div>
                          <div class="ml-auto text-right" style="width: 300px;">

                            <v-btn
                              :color="form.akreditasi_status === 'A' ? '#4CAF50' : form.akreditasi_status === 'B' ? '#FFC107' : form.akreditasi_status === 'C' ? '#FF5722' : '#9E9E9E'"
                              class="white--text text-capitalize"
                              elevation="0"
                              @click="openDialog"
                              style="border-radius: 4px;">
                              Akreditasi: {{ form.akreditasi_status }}
                            </v-btn>
                          </div>
                        </div>
                        <v-divider class="mt-3"></v-divider> -->

                        <v-row>
                          <v-col cols="12" md="2" class="pb-0 pr-0">
                            <v-card flat style="border-radius: 6px;">
                              <v-card-text class="py-0 pr-0">
                                <v-img
                                  height="200"
                                  width="100%"
                                  :src="detail.image_url === '' || detail.image_url === null ? require('@/assets/image/image_default.png') : detail.image_url" 
                                  :alt="detail.image_url === '' || detail.image_url === null ? require('@/assets/image/image_default.png') : detail.banner_url"
                                  class="text-center d-flex align-center">
                                  <div 
                                    class="d-flex aling-center justify-center" 
                                    style="width: 100%; height: auto;">
                                  </div>
                                </v-img>
                              </v-card-text>
                            </v-card>
                          </v-col>
                          <v-col cols="12" md="5" class="">
                            <table style="border: none; width: 100%; border-collapse: collapse;">
                              <tr>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Nama Siswa
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ detail.name }}
                                </td>
                              </tr>
                              <tr>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Nama Sekolah
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ detail.school_name }}
                                </td>
                              </tr>
                              <tr>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Kode NISN
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ detail.code }}
                                </td>
                              </tr>
                              <tr>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Jenis Kelamin
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ detail.gender === '' || detail.gender === null ? '-' : detail.gender}}
                                </td>
                              </tr>
                              <tr>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Agama
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ detail.religion === '' || detail.religion === null ? '-' : detail.religion }}
                                </td>
                              </tr>
                            </table>
                          </v-col>
                          <v-col cols="12" md="5" class="">
                            <table style="border: none; width: 100%; border-collapse: collapse;">
                              <tr>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Tempat, Tanggal Lahir
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ detail.birth_place === '' || detail.birth_place === null ? '-' : detail.birth_place }}, {{ detail.birth_date | date }}
                                </td>
                              </tr>
                              <tr>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  NIK
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ detail.nik === '' || detail.nik === null ? '-' : detail.nik }}
                                </td>
                              </tr>
                              <tr>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Tinggi Badan
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ detail.tinggi_badan === '' || detail.tinggi_badan === null ? '-' : detail.tinggi_badan }} cm
                                </td>
                              </tr>
                              <tr>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Berat Badan
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ detail.berat_badan === '' || detail.berat_badan === null ? '-' : (detail.berat_badan*1) }} kg
                                </td>
                              </tr>
                              <tr>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 200px; min-width: 200px; max-width: 200px;" class="black--text">
                                  Jarak Rumah
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 2px; text-align: right; width: 30px; min-width: 30px; max-width: 30px;"  class="black--text">
                                  :
                                </td>
                                <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 4px 12px; text-align: left; width: 100%;"  class="black--text">
                                  {{ detail.jarak_rumah === '' || detail.jarak_rumah === null ? '-' : (detail.jarak_rumah) }} {{ detail.jarak_rumah === 'Kurang dari 1 km' || detail.jarak_rumah === 'Lebih dari 1 km' ? '' : 'km' }}
                                </td>
                              </tr>
                            </table>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>

                    <v-card flat class="mt-5"
                      style="border-radius: 6px;">
                      <v-card-text>
                        <div class="fs-13 font_weight_600 mb-2 black--text">
                          Data Alamat
                        </div>
                        <div  class="black--text fs-13 px-1 mb-2 font_weight_600">
                          {{ detail.address === '' || detail.address === null ? '-' : detail.address }}, RT/RW {{ detail.rt_rw === '' || detail.rt_rw === null ? '-' : detail.rt_rw }}, Kelurahan {{ detail.village_name }}, Kecamatan {{ detail.subdistrict_name }}, Kota / Kabupaten {{ detail.city_name }}, Provinsi {{ detail.province_name }}
                        </div>

                        <v-divider class="mt-2 mb-3"></v-divider>

                        <div
                          class="" v-if="!process.load">
      
                          <gmap-map
                            :center="center"
                            :zoom="12"
                            :options="{
                              zoomControl: true,
                              mapTypeControl: false,
                              scaleControl: false,
                              streetViewControl: false,
                              rotateControl: false,
                              fullscreenControl: true,
                              disableDefaultUi: false
                            }"
                            :clickable="false"
                            style="width: 100%; height: 320px;">
      
                            <gmap-marker
                              :position="center"
                              :draggable="false">
                            </gmap-marker>
                          </gmap-map>
                        </div>
                      </v-card-text>
                    </v-card>

                    <v-card flat class="mt-5"
                      style="border-radius: 6px;">
                      <v-card-text>
                        <div class="fs-13 font_weight_600  black--text d-flex justify-space-between align-start" style="margin-bottom: 5px;">
                          <div>
                            Data Keluarga
                          </div>
                          <div>
                            <v-btn
                              :disabled="process.form"
                              dark
                              elevation="0"
                              small
                              @click="dialog.form = true; editFamily();"
                              :color="set_color"
                              class="white--text text-capitalize"
                              style="border-radius: 6px;">
                              Tambah
                            </v-btn>
                          </div>
                        </div>

                        <div  class="mx-1">
                          <table style="border: none; width: 100%; border-collapse: collapse;">
                            <tr>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                Aksi
                              </th>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                Nama
                              </th>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;"  class="black--text">
                                Hubungan
                              </th>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                Jenis Kelamain
                              </th>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                Pekerjaan
                              </th>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                Pendidikan
                              </th>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                No. Telephone
                              </th>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                Penghasilan
                              </th>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                Tempat, Tanggal Lahir
                              </th>
                              <th style="background-color: #f3f4f6; font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                                Status
                              </th>
                            </tr>
                            <tr v-for="(family, index) in detail.family" :key="index">
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                <v-btn
                                  :disabled="process.form"
                                  dark
                                  @click="editFamily(family); dialog.form = true;"
                                  elevation="0"
                                  small
                                  :color="set_color"
                                  class="white--text text-capitalize"
                                  style="border-radius: 6px;">
                                  Ubah
                                </v-btn>
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;" class="black--text">
                                {{ family.siswa_family_name }}
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 1px; white-space: nowrap;"  class="black--text">
                                {{ family.siswa_family_relation }}
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                {{ family.siswa_family_gender }}
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                {{ family.siswa_family_job === '' || family.siswa_family_job === null ? '-' : family.siswa_family_job }}
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                {{ family.siswa_family_last_education === '' || family.siswa_family_last_education === null ? '-' : family.siswa_family_last_education }}
                              </td> 
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                {{ family.siswa_family_mobile_phone_number === '' || family.siswa_family_mobile_phone_number === null ? '-' : `+${family.siswa_family_mobile_phone_number}` }}
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                <span v-if="family.siswa_family_penghasilan !== '' && family.siswa_family_penghasilan !== null">
                                  {{ family.siswa_family_penghasilan | price }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left;width: 1px; white-space: nowrap;"  class="black--text">
                                {{ family.siswa_family_birth_place }}, {{ family.siswa_family_birth_date | date }}
                              </td>
                              <td style="font-size: 13px; font-weight: 600; z-index: 1; padding: 8px 12px; text-align: left; width: 100%;"  class="black--text">
                                {{ family.siswa_family_status }}
                              </td>
                            </tr>
                          </table>
                        </div>
                      </v-card-text>
                    </v-card>

                    <v-card flat class="mt-5"
                      style="border-radius: 6px;">
                      <v-card-text>
                        <DocumentSiswa :detail="detail" />
                      </v-card-text>
                    </v-card>

                    <div v-if="message.error.length > 0"
                      class="text-left mt-0">
                      <div
                        class="error--text d-flex align-start">
                        <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                        
                        <span
                          class="ml-1">
                          {{ message.error }}
                        </span>
                      </div>
                    </div>
                  </v-card-text>
                  <v-card-actions class="pa-5">
                    <v-spacer/>
                    <v-btn
                      :to="'/manajemen-akademik/data-pengguna/data-siswa/edit/' + detail.school_id + '/' + detail.id"
                      :disabled="process.form"
                      dark
                      elevation="0"
                      :color="set_color"
                      class="white--text text-capitalize"
                      style="border-radius: 6px;">
                      Ubah
                    </v-btn>
  
                    <v-btn
                      to="/manajemen-akademik/data-pengguna/data-siswa"
                      :disabled="process.form"
                      width="85"
                      outlined
                      elevation="0"
                      color="red"
                      style="border-radius: 6px;"
                      class="fs-13 font-weight-bold text-capitalize white--text">
                      Kembali
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { TokenService } from "@/service/Storage.Service";
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import axios from "axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      data () {
        return {
          filter: {
            school_id: '',
          },
          dialog: {
            form: false,
          },
          step_index: 1,
          detail: {},
          center: {
            lat: -7.703889, 
            lng: 110.60166
          },
          
          upload: {
            image: '',
            banner_url: null,
            galery_array: null
          },
          form: {
            id: '',
            mobile_phone_number: '',
            name: '',
            birth_place: '',
            birth_date: '',
            relation: '',
            job: '',
            penghasilan: 0,
            status: '',
            last_education: '',
            address: '',
            gender: ''
          },
          province: [],
          city: [],
          subdistrict: [],
          school: [],
          village: [],
          kurikulum: [],
  
          process: {
            load: true,
            image: false,
            form: false,
            banner_url: false,
            galery_array: false
          },
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {
        uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue'),
        DocumentSiswa: () => import(/* webpackPrefetchCategory: true */ '@/components/siswa/document.vue')
      },
      watch: {
        'upload.image': {
          handler: function () {
            if (this.upload.image) {
              this.process.image = this.upload.image.process
  
              if (!this.process.image) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.logo_url = this.upload.image.fileuri
  
                // this.save_image()
              }
            }
          },
          deep: true
        },
        'upload.banner_url': {
          handler: function () {
            if (this.upload.banner_url) {
              this.process.banner_url = this.upload.banner_url.process
  
              if (!this.process.banner_url) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.banner_url = this.upload.banner_url.fileuri
  
                // this.save_image()
              }
            }
          },
          deep: true
        },
        'upload.galery_array': {
          handler: function () {
            if (this.upload.galery_array) {
              this.process.galery_array = this.upload.galery_array.process
  
              if (!this.process.galery_array) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.galery_array.push({
                  galery_url: this.upload.galery_array.fileuri,
                  galery_desc: ''
                })
  
                // this.save_image()
  
                this.upload.galery_array = null
              }
            }
          },
          deep: true
        },
        // 'options': {
        //   handler () {
        //     let pagination = { row: this.limit, page: 1 }
            
        //     this.fetch(pagination)
        //   },
        //   deep: true
        // }
      },
      computed: {
        token () {
          return this.$store.state.token
        },
        user () {
          this.filter.school_id = this.$store.state.user.school_id === undefined || this.$store.state.user.school_id === null ? this.$store.state.school !== undefined && this.$store.state.school !== null && this.$store.state.school !== '' ? this.$store.state.school : '' : this.$store.state.user.school_id
          return this.$store.state.user
        },
        set_color () {
          return this.$store.state.color
        }
      },
      mounted () {
        this.fetchDetail()
      },
      methods: {
        async fetchDetail() {
            this.process.load = true
           let params = {
            id: this.$route.params.id,
            school_id: this.$route.params.school_id
          }
          let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/siswa/detail' : 'siswa/detail'
  
          await get(`${url}`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              // this.kurikulum = res.results.data
              this.detail = res.results.data
              this.center = {
                lat: res.results.data.latitude*1,
                lng: res.results.data.longitude*1
              }
  
              this.process.load = false
            }
          })
        },

        editFamily(item) {
          if (this.$refs.form) this.$refs.form.reset()
        
          this.form = {
            siswa_family_id: item !== undefined ? item.siswa_family_id : '',
            mobile_phone_number: item !== undefined ? item.siswa_family_mobile_phone_number.replace('62', '') : '',
            name: item !== undefined ? item.siswa_family_name : '',
            birth_place: item !== undefined ? item.siswa_family_birth_place : '',
            birth_date: item !== undefined ? item.siswa_family_birth_date : '',
            relation: item !== undefined ? item.siswa_family_relation : '',
            job: item !== undefined ? item.siswa_family_job : '',
            penghasilan: item !== undefined ? item.siswa_family_penghasilan : 0,
            status: item !== undefined ? item.siswa_family_status : '',
            last_education: item !== undefined ? item.siswa_family_last_education : '',
            address: item !== undefined ? item.siswa_family_address : '',
            school_id: this.$route.params.school_id,
            siswa_id: this.$route.params.id,
            gender: item !== undefined ? item.siswa_family_gender : ''
          }
          this.process.form = false
          this.message.error = ''
        },

        async save () {
          this.message.error = ''

          const isValid = await this.$refs.form.validate()

          if (isValid) {
            this.process.form = true

            let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? this.form.siswa_family_id === '' ? 'pegawai/siswa/add_family' : 'pegawai/siswa/update_family' : this.form.siswa_family_id === '' ? 'siswa/add_family' : 'siswa/update_family'

            // SAVE TO REST API
            await post(url, {
              data: {
                siswa_family_id: this.form.siswa_family_id,
                school_id: this.form.school_id,
                siswa_id: this.form.siswa_id,
                name: this.form.name,
                birth_place: this.form.birth_place,
                birth_date: this.form.birth_date,
                relation: this.form.relation,
                job: this.form.job,
                penghasilan: this.form.penghasilan,
                status: this.form.status,
                last_education: this.form.last_education,
                address: this.form.address,
                mobile_phone_number: this.form.mobile_phone_number === '' || this.form.mobile_phone_number === null ? '' : `62${this.form.mobile_phone_number}`,
                gender: this.form.gender
              }
            })
            .then(response => {
              let res = response.data
              
              this.process.form = false

              if (res.status === 200) {
                this.dialog.form = false

                this.dialog.snackbar = true
                this.message.success = res.message

                this.dialog.fullscreen = false

                this.fetchDetail()

              } else {
                this.message.error = res.message
              }
            })

          } else {
            // AUTO FOCUS ON TEXT-FIELD
            setTimeout(() => {
              const errors = Object.entries(this.$refs.form.errors)
                .map(([key, value]) => ({ key, value }))
                .filter(error => error['value'].length)
              this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
            }, 10)
          }
        },

        toDelete (id) {
          this.selected.delete = [id]

          this.dialog.delete = true
        },
        async deletes () {
          this.message.error = ''

          this.process.delete = true

          let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/siswa/delete' : 'siswa/delete'

          await post(`${url}`, {
            data: {
              id: this.selected.delete[0]
            }
          }).then(response => {
            let res = response.data

            this.process.delete = false

            if (res.status === 200) {

              this.dialog.delete = false

              this.selected.row = []
              this.selected.delete = []
              
              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })
        },
      },
      created () {
      }
    }
  </script>